/* eslint-disable no-continue */

/**
 * This function reduces a nested object to a single level.
 */
export default {
  methods: {
    flattenObject(ob) {
      const toReturn = {};

      for (const i in ob) {
        if (!Object.prototype.hasOwnProperty.call(ob, i)) continue;

        if ((typeof ob[i]) === 'object') {
          const flatObject = this.flattenObject(ob[i]);
          for (const x in flatObject) {
            if (!Object.prototype.hasOwnProperty.call(flatObject, x)) continue;

            toReturn[`${i}.${x}`] = flatObject[x];
          }
        } else {
          toReturn[i] = ob[i];
        }
      }
      return toReturn;
    },
  },
};
